import script from "./AddNote.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddNote.vue?vue&type=script&setup=true&lang=ts"

import "./AddNote.vue?vue&type=style&index=0&id=1bfe0283&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bfe0283"]])

export default __exports__